import { ChatterTrackingPage } from '@/modules/tracking/chatter-tracking/chatter-tracking-page.tsx'

export const ChatterTrackingView = () => {
  return <ChatterTrackingPage />
}
